import { toBase58Address } from '@particle-network/auth';
import { ParticleChains, chains } from '@particle-network/chains';
import { particleChain, particleChainV2 } from '../../config';
import { formatPng } from '../../utils';
import { icon as solanaIcon, lightIcon as solanaLightIcon } from './icon/solana';
const scanMap = Object.fromEntries(Object.entries(ParticleChains).map((item) => [item[1].id, item[1].blockExplorerUrl]));
export const getScanUrl = (data) => {
    const { chainType, chainId, chainName, address, chainNetwork, tokenId } = data;
    if (chainType == 'solana') {
        return `https://solscan.io/token/${address}?cluster=${chainNetwork}`;
    }
    else if (chainName.toLowerCase() == 'tron') {
        return `${scanMap[chainId] || 'https://etherscan.io'}/#/token721/${toBase58Address(address)}/${tokenId}`;
    }
    else if (chainName.toLowerCase() === 'thundercore') {
        let url = `${scanMap[chainId] || 'https://etherscan.io'}/address/${address}`;
        if (tokenId) {
            url += `?tokenId=${tokenId}`;
        }
        return url;
    }
    else {
        let url = `${scanMap[chainId] || 'https://etherscan.io'}/token/${address}`;
        if (tokenId) {
            url += `?tokenId=${tokenId}`;
        }
        return url;
    }
};
export const getTXUrl = (data) => {
    const { chainType, chainId, chainName, hash, chainNetwork } = data;
    if (chainType == 'solana') {
        return `https://solscan.io/tx/${hash}?cluster=${chainNetwork}`;
    }
    else if (data.chainId === particleChain.id) {
        return `${particleChain.blockExplorerUrl}/tx/${hash}`;
    }
    else if (data.chainId === particleChainV2.id) {
        return `${particleChainV2.blockExplorerUrl}/tx/${hash}`;
    }
    else if (chainName.toLowerCase() == 'tron') {
        return `${scanMap[chainId] || 'https://etherscan.io'}/#/transaction/${hash.replace(/^0x/, '')}`;
    }
    else {
        return `${scanMap[chainId] || 'https://etherscan.io'}/tx/${hash}`;
    }
};
export const getNativeIcon = (chainInfo) => {
    const defaultIcon = 'https://static.particle.network/token-list/ethereum/native.png';
    if (!chainInfo)
        return defaultIcon;
    const symbol = chainInfo?.nativeCurrency?.symbol;
    let iconUrl = chainInfo?.nativeIcon || chainInfo?.icon;
    if (symbol?.toLowerCase() === 'eth') {
        iconUrl = defaultIcon;
    }
    if (iconUrl) {
        iconUrl = formatPng(iconUrl);
    }
    return iconUrl;
};
export const getChainInfo = () => {
    let sIcon = solanaLightIcon;
    const themeMode = typeof window === 'undefined' ? '' : (location.href.match(/theme=(\w+)/) || [])[1] || window.storage.getItem('themeMode') || '';
    if (!themeMode || themeMode == 'dark') {
        sIcon = solanaIcon;
    }
    const result = Object.fromEntries([...new Set(Object.entries(ParticleChains).map((item) => item[1].name))].map((name) => {
        const data = Object.entries(ParticleChains).filter((o) => o[1].name == name);
        const { icon, chainType } = data[0][1];
        const evm1559support = !!data[0][1]?.features?.find((item) => item.name == 'EIP1559');
        const symbol = data[0][1].nativeCurrency.symbol;
        // chainData  变更!!!
        // 旧：{Mainnet: 66, Testnet: 65}
        // 新：{65:{}, 66{}}
        // const chainData = Object.fromEntries(data.map((o) => [o[1].network, o[1].id]));
        const chainData = Object.fromEntries(data.map((item) => {
            return [item[1].id, item[1]];
        }));
        const nativeIcon = getNativeIcon(data[0][1]);
        return [
            name,
            {
                icon,
                nativeIcon,
                symbol,
                evm1559support,
                chainType,
                chainData,
            },
        ];
    }));
    return result;
};
export const getChainList = (testNetWork, chainId, chainName) => {
    const chainInfo = getChainInfo();
    let list = [];
    if (testNetWork) {
        list = Object.entries(chainInfo)
            .map((item) => {
            let [name, data] = item;
            let { chainData, icon, symbol, evm1559support, chainType } = data || {};
            const _list = Object.keys(chainData).map((key) => {
                let result = {
                    chainName: `${name}`,
                    chainNetwork: chainData[key].network,
                    symbol: chainData[key].nativeCurrency.symbol,
                    fullname: chainData[key].fullname,
                    evm1559support,
                    chainType: chainType || 'evm',
                    chainId: chainData[key].id,
                    scanUrl: '',
                    txUrl: '',
                    icon,
                    selected: chainId == chainData[key].id && name.toLowerCase() == chainName.toLowerCase(),
                    decimals: chainData[key]?.nativeCurrency?.decimals,
                    chainData,
                };
                return result;
            });
            // 如果 _list chainNetwork的值有 Devnet 和 Testnet ，并且Devnet在Testnet前面，那么就调整 这两个item的顺序，Mainnet始终在最前面
            try {
                const item0 = _list.find((item) => item.chainNetwork == 'Mainnet');
                const item1 = _list.find((item) => item.chainNetwork == 'Devnet');
                const item2 = _list.find((item) => item.chainNetwork == 'Testnet');
                if (item1 && item2) {
                    const index = _list.indexOf(item1);
                    const index2 = _list.indexOf(item2);
                    if (index < index2) {
                        _list[index] = item2;
                        _list[index2] = item1;
                    }
                }
                if (item0) {
                    const index = _list.indexOf(item0);
                    if (index != 0) {
                        _list.splice(index, 1);
                        _list.unshift(item0);
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
            return _list;
        })
            .flat(2);
    }
    else {
        // 只显示主网的列表数据，有的链有多个主网，比如：Polygon，有 Polygon 和 Polygon Matic
        list = Object.entries(chainInfo).map((item) => {
            const result = Object.entries(item[1].chainData)
                .filter((o) => o[1].network.toLowerCase() === 'mainnet')
                .map((o) => {
                const [_, data] = o;
                return {
                    chainName: data.name,
                    chainNetwork: data.network,
                    icon: data.icon,
                    chainId: data.id,
                    scanUrl: '',
                    txUrl: '',
                    symbol: data.nativeCurrency.symbol,
                    fullname: data.fullname,
                    chainType: data.chainType || 'evm',
                    evm1559support: data.supportEIP1559,
                    selected: data.id == chainId && data.name.toLowerCase() == chainName.toLowerCase(),
                    decimals: data.nativeCurrency?.decimals,
                    chainData: data,
                };
            });
            return result;
        });
        list = list.flat(2);
    }
    const allChainInfos = chains.getAllChainInfos();
    return sortByAllChainInfosOrder(list, allChainInfos);
};
const sortByAllChainInfosOrder = (list, allChainInfos) => {
    const chainTypeIndexMap = {};
    allChainInfos.forEach((info, index) => {
        chainTypeIndexMap[`${info.chainType}-${info.id}`] = index;
    });
    list.sort((a, b) => {
        const indexA = chainTypeIndexMap[`${a.chainType}-${a.chainId}`];
        const indexB = chainTypeIndexMap[`${b.chainType}-${b.chainId}`];
        if (indexA === undefined && indexB === undefined) {
            return 0;
        }
        else if (indexA === undefined) {
            return 1;
        }
        else if (indexB === undefined) {
            return -1;
        }
        return indexA - indexB;
    });
    return list;
};
//# sourceMappingURL=chainInfo.js.map